/** Shopify CDN: Minification failed

Line 35:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 52:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 53:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 54:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 55:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 57:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 59:9 Transforming let to the configured target environment ("es5") is not supported yet
Line 60:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 77:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 78:4 Transforming const to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 21:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 38:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 39:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 40:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 41:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 43:4 Transforming let to the configured target environment ("es5") is not supported yet
Line 45:9 Transforming let to the configured target environment ("es5") is not supported yet
Line 46:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 63:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 64:4 Transforming const to the configured target environment ("es5") is not supported yet

**/
/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCustomContactForm = {
  init: function () {

  // Selectors
  const $contactForm = $('.contact-form__form');

  // Contact form checkbox validation
  if ($('[data-is-required]').length){
    var $checkboxGroup = $('.contact-form__list .checkbox');
    $checkboxGroup.prop('required', true);

    $('.contact-form__list .checkbox').on('change', function(){
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(":checked")) {
        $checkboxGroup.prop('required', false);
      }
    })
  }

  $contactForm.on('submit', function(e) {

    const $form = $(this);
    const $formBlocks = $('.contact-form__blocks [data-checkbox-required]', $form);
    const $errorMessage = window.PXUTheme.translation.contact_form_checkbox_error;
    const $errorMessageContainer = $('.form__error', $form);

    let completeForm = true;

    for (let i = 0; i < $formBlocks.length; i++ ) {
      const $checkbox = $('input[type=checkbox]:checked', $formBlocks[i]);
      if ($checkbox.length) {
        completeForm = true;
      } else {
        $errorMessageContainer.html($errorMessage);
        completeForm = false;
      }
    }

    if (completeForm) {
      return;
    } else {
      event.preventDefault();
    }
  });
  },
  unload: function () {
    const $contactForm = $('.contact-form__form');
    const $submitButton = $contactForm.find(':submit');

    $submitButton.off();

  }
}

/******/ })()
;